import { z } from "zod";
/**
 * Schema for creating a share
 */
export const createShareSchema = z.object({
    title: z.string().min(1).max(200),
    description: z.string().max(500).optional(),
    result_ids: z.array(z.number().int().positive()).min(1), // At least one vehicle
    password: z.string().min(4).max(100).optional(),
    expires_at: z.string().datetime().optional(),
});
/**
 * Schema for creating a shared job list
 */
export const createShareListSchema = z.object({
    title: z.string().min(1).max(200),
    description: z.string().max(500).optional(),
    job_ids: z.array(z.string().uuid()).min(1),
    password: z.string().min(4).max(100).optional(),
    expires_at: z.string().datetime().optional(),
});
/**
 * Schema for updating a share
 */
export const updateShareSchema = z.object({
    title: z.string().min(1).max(200).optional(),
    description: z.string().max(500).optional(),
    result_ids: z.array(z.number().int().positive()).min(1).optional(),
    password: z.string().min(4).max(100).optional(),
    expires_at: z.string().datetime().optional(),
    is_active: z.number().int().min(0).max(1).optional(),
});
/**
 * Schema for accessing a share
 */
export const accessShareSchema = z.object({
    uuid: z.string().uuid(),
    password: z.string().min(4).max(100).optional(),
});
/**
 * Schema for deleting a share
 */
export const deleteShareSchema = z.object({
    id: z.string().uuid(), // Changed from number to string (UUID)
});
//# sourceMappingURL=share.schema.js.map